<template>
  <client-layout>
    <update-recurrent-intervention-dialog
      v-model="isUpdateRecurrentInterventionDialogOpened"
      :recurrentIntervention="recurrentInterventionToUpdate"
      @updated="fetchRecurrentInterventions"
    />
    <new-recurrent-intervention-dialog
      v-model="isNewRecurrentInterventionDialogOpened"
      :maker="newRecurrentInterventionMaker"
      :client="newRecurrentInterventionClient"
      @added="fetchRecurrentInterventions"
    />
    <v-row no-gutters align="center" class="content-header">
      <span class="font-weight-bold">Interventions récurrentes</span>
      <v-spacer></v-spacer>
      <v-btn :disabled="!$canWrite" dark color="primary" elevation="0" @click="$canWrite && (isNewRecurrentInterventionDialogOpened = true)">
        <v-icon left>add</v-icon>
        Nouvelle récurrence
      </v-btn>
    </v-row>
    <div class="relative">
      <v-row no-gutters justify="center" align="center" class="py-8" style="min-height: 100px;" v-if="isFetchingRecurrentInterventions">
        <v-progress-linear
          color="primary"
          indeterminate
          rounded
          height="6"
          class="absolute-progress"
        ></v-progress-linear>
      </v-row>
      <n-card v-else-if="!recurrentInterventions.length">
        <v-row
          no-gutters
          justify="center"
          align="center"
          class="pa-4 text--secondary"
          style="min-height: 100px;"
        >
          Aucune intervention récurrente pour ce client
        </v-row>
      </n-card>
      <template v-else>
        <recurrent-intervention-card
          v-for="recurrentIntervention in recurrentInterventions"
          :key="recurrentIntervention.id"
          :value="recurrentIntervention"
          clickable
          @click="$canWrite && (recurrentInterventionToUpdate = recurrentIntervention)"
          class="mb-4"
        />
      </template>
    </div>
  </client-layout>
</template>

<script>
import ClientLayout from '@/views/settings/clients/ClientLayout.vue';
import RecurrentInterventionCard from '@/components/RecurrentInterventions/Card.vue';
import NewRecurrentInterventionDialog from '@/components/RecurrentInterventions/NewDialog.vue';
import UpdateRecurrentInterventionDialog from '@/components/RecurrentInterventions/UpdateDialog.vue';
import { mapActions, mapGetters, mapState } from 'vuex';

export default {
  data: () => ({
    isFetchingRecurrentInterventions: false,
    isNewRecurrentInterventionDialogOpened: false,
    // isUpdateRecurrentInterventionDialogOpened: false,
    recurrentInterventionToUpdate: null,
  }),

  computed: {
    ...mapState(`model/client`, [
      `company`,
      `currentAdminClient`,
    ]),
    ...mapGetters(`ui/settingsClients`, [
      `recurrentInterventions`,
    ]),
    newRecurrentInterventionMaker() {
      return this.company;
    },
    newRecurrentInterventionClient() {
      return this.currentAdminClient;
    },
    isUpdateRecurrentInterventionDialogOpened: {
      get() { return this.recurrentInterventionToUpdate !== null; },
      set() { this.recurrentInterventionToUpdate = null; },
    },
  },

  methods: {
    ...mapActions(`ui/settingsClients`, [
      `fetchRecurrentInterventionsForMakerAndClient`,
    ]),
    async fetchRecurrentInterventions() {
      this.isFetchingRecurrentInterventions = true;
      await this.fetchRecurrentInterventionsForMakerAndClient();
      this.isFetchingRecurrentInterventions = false;
    },
  },

  beforeMount() {
    this.fetchRecurrentInterventions();
  },

  components: {
    ClientLayout,
    RecurrentInterventionCard,
    NewRecurrentInterventionDialog,
    UpdateRecurrentInterventionDialog,
  },
};
</script>
